import React from "react";
import { parseGid } from "@shopify/hydrogen";

interface TolstoyWidgetProps {
  productId?: string;
  productTags?: string[];
  publishId: string;
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "tolstoy-carousel": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & {
        "data-tags"?: string;
        "data-product-id"?: string;
        "data-publish-id"?: string;
        class?: string;
      };
    }
  }
}

export const TolstoyWidget = ({
  productId,
  productTags = [],
  publishId,
}: TolstoyWidgetProps) => {
  const numericProductId = productId ? parseGid(productId).id : undefined;
  const tagsString = productTags.join(",");

  return (
    <tolstoy-carousel
      data-tags={tagsString}
      data-publish-id={publishId}
      class="tolstoy-carousel"
      data-product-id={numericProductId}
    />
  );
};
